import type { ReactElement } from "react";

import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";

import type FindEmployeeLocationFilter from "../../../models/EmployeeLocationFilter/EmployeeLocationFilter";
import { EmployeeLocationSelector } from "../../EmployeeLocationSelector/EmployeeLocationSelector";

const EmployeeLocationFilter = ({
    filter,
    value,
    onFilterUpdate,
}: IFilterViewBaseProps<FindEmployeeLocationFilter>): ReactElement | null => (
    <EmployeeLocationSelector
        value={value}
        onChange={onFilterUpdate}
        options={filter.options}
    />
);

export default EmployeeLocationFilter;
